if (!customElements.get('btl-native-sku')) {
  customElements.define('btl-native-sku', class extends HTMLElement {
    connectedCallback() {
      this.unsubscribe?.();
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data?.sectionId) !== this.dataset.section) return;
        const value = typeof data.variant?.sku === 'string' ? data.variant.sku : '';
        const cell = this.querySelector('[data-sku-value]');
        if (cell) cell.textContent = value;
        this.hidden = !value.trim();
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}
